module.exports = __webpack_public_path__ + "static/media/freedom-logo.d2e0b72f.png";